/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ spaceName: NonNullable<unknown> }} Project_Access_Missing_SpaceInputs */



/**
* | output |
* | --- |
* | "Missing access to {spaceName}" |
*
* @param {Project_Access_Missing_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_missing_space = /** @type {((inputs: Project_Access_Missing_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_Missing_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehlender Zugriff auf ${i?.spaceName}`)
	return /** @type {LocalizedString} */ (`Missing access to ${i?.spaceName}`)
});